import React from 'react';

type BankIconProps = {
  width?: number;
  height?: number;
  /** Panel fill (columns). */
  panelColor?: string;
  /** Roof fill. */
  roofColor?: string;
  /** Stroke/ink color for all outlines. */
  inkColor?: string;
};

export function BankIcon({
  width = 48,
  height = 48,
  panelColor = '#EAEFF2',
  roofColor = '#BCCAD2',
  inkColor = '#5E6D79',
  ...props
}: BankIconProps): JSX.Element {
  return (
    <svg
      aria-label='Bank Icon'
      role='img'
      width={width}
      height={height}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <desc>Bank Icon</desc>
      {/* fill/stroke set via style, not attribute - see loyalty-header-wave-filter.tsx */}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4535 11.6543H6.62891V29.962H11.4535V11.6543Z'
        style={{ fill: panelColor, stroke: inkColor }}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.3754 11.6543H24.5508V29.962H29.3754V11.6543Z'
        style={{ fill: panelColor, stroke: inkColor }}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.4145 11.6543H15.5898V29.962H20.4145V11.6543Z'
        style={{ fill: panelColor, stroke: inkColor }}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32 30.5H4'
        style={{ stroke: inkColor }}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.1335 12.0831H3.875L18.0473 2.5L32.1335 12.0831Z'
        style={{ fill: roofColor, stroke: inkColor }}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
